module.exports = __webpack_public_path__ + "img/ot4.22fa7713.png";